import { useCallback } from 'react'

import styled from '@emotion/styled'
import type { TFunction } from 'i18next'

import type { LinkAdapterProps } from '@cash-web/support/ui-components'

interface MoreResultsButtonProps<T> extends LinkAdapterProps<T> {
  query: string
  t: TFunction
}

const ButtonContainer = styled.div`
  margin: 10px auto 30px;
  max-width: 300px;
`

const MoreResultsButton = <T,>({ Link, linkProps, query, t }: MoreResultsButtonProps<T>) => {
  const encodedQuery = encodeURIComponent(query)
  const route = `/search#${encodedQuery}`

  const handleClick = useCallback(
    (event: { preventDefault: () => void }) => {
      event.preventDefault()
      const currentPath = window.location.pathname

      const pathSegments = currentPath.split('/').filter(Boolean)
      const basePath = `/${pathSegments[0]}` // Get first segment (e.g., `/help`)

      const newPath = `${basePath}${route}`

      // push new route
      window.history.pushState({}, '', newPath)

      // reload page
      window.location.reload()
    },
    [route]
  )

  const StyledLink = styled(Link)`
    text-decoration: none;
    display: flex;
    background: ${props => props.theme.colors.secondaryButtonBackground};
    border-radius: 24px;
    color: ${props => props.theme.colors.label};
    justify-content: center;
    align-items: center;
    padding: 12px 100px;
    font-weight: 500; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  `

  return (
    <ButtonContainer>
      <StyledLink {...linkProps} href={route} to={route} onClick={handleClick}>
        <span>{t('More results', { context: 'search view more results button' })}</span>
      </StyledLink>
    </ButtonContainer>
  )
}

export default MoreResultsButton
